import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { getBrandCustom } from "../../../../../../../../../../../util/getCustomColor";

export const DetailsHeader = styled("header")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",

  borderBottom: `1px solid ${colors.gray200}`,
  marginBottom: "24px",
  paddingBottom: "24px",
}));

type Props = {
  hasSubcontractor?: boolean;
};

export const HeaderMessage = styled("span")(({ hasSubcontractor = false }: Props) => ({
  fontFamily: "Manrope",
  fontSize: 16,
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: 0.5,
  color: colors.gray600,
  "& > span": {
    fontWeight: 700,
    letterSpacing: 0.15,
    color: hasSubcontractor
      ? colors.warning600
      : getBrandCustom("primaryColor", colors.brandBlue600),
  },
}));

export const AvatarWrapper = styled("div")(() => ({
  width: "345px",
}));

export const NoAvatarWrapper = styled(AvatarWrapper)(() => ({}));

export const NoAvatarComponent = styled("div")(() => ({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",

  border: `1px dashed ${colors.gray200}`,
  borderRadius: "12px",
  padding: "35px 55px",

  "& > img": {
    height: 103,
    width: 103,
    borderRadius: 100,
  },

  "& > span": {
    color: colors.gray400,
    textAlign: "center",

    fontFamily: "Manrope",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.5px",
    paddingTop: "16px",
  },
}));

export const Wrapper = styled("div")(() => ({
  height: "100%",
}));

export const SectionWrapper = styled("div")(() => ({
  "& > div": {
    marginBottom: 24,
  },
}));

export const SectionTitle = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: 16,
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: 0.15,
}));

export const MemberDetailsContainer = styled("div")(() => ({
  display: "flex",
  gap: "24px",
  width: "100%",

  borderBottom: `1px solid ${colors.gray200}`,
  paddingBottom: "20px",
}));

export const MemberDetailsWrapper = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  width: "100%",
}));

export const MemberDetailsRow = styled("div")(() => ({
  display: "flex",
  gap: "24px",
  width: "100%",
}));

export const MemberDetail = styled("div")(() => ({
  alignItems: "flex-start",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  padding: "10px 0",
  textAlign: "left",
  width: "100%",
}));
